import { render, staticRenderFns } from "./helpText.vue?vue&type=template&id=059acd28&scoped=true&"
import script from "./helpText.vue?vue&type=script&lang=js&"
export * from "./helpText.vue?vue&type=script&lang=js&"
import style0 from "./helpText.vue?vue&type=style&index=0&id=059acd28&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059acd28",
  null
  
)

export default component.exports